import React from "react";
import { Globe, Users, Scale, Plane } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const trustCategories = [{
  label: "Cross-Cultural Alliances",
  icon: Globe
}, {
  label: "HNIs & Families",
  icon: Users
}, {
  label: "Legal Professionals",
  icon: Scale
}, {
  label: "Global Indians (NRIs)",
  icon: Plane
}];
export default function TrustedByFamiliesAndProfessionals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="trusted-by-families-and-professionals" ref={ref} className="dark bg-background text-foreground py-20 px-6 md:px-12 lg:px-24 border-t border-border/10">
      <div className="max-w-7xl mx-auto">
        <div className={cn("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {trustCategories.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center group">
              <div className="mb-6 p-4 rounded-full border border-primary/20 bg-primary/5 group-hover:bg-primary/10 group-hover:border-primary/40 transition-colors duration-300">
                <item.icon strokeWidth={1.5} className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-lg font-medium tracking-wide text-foreground/90 font-sans">
                {item.label}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}